import MaterialTable from "material-table";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { CommonUrl, NONCE, TIME_STAMP,mySearchFieldStyle,logoutMsg } from "../../common-url/CommonUrl";
import { makeStyles } from "@material-ui/core/styles";
import { Popover, Typography } from "@material-ui/core";
import { WidgetForMasterUser } from "../../../_metronic/_partials/widgets/mixed/WidgetForMasterUser";
import { useHistory } from "react-router-dom";
// import MenuBookTwoToneIcon from '@material-ui/icons/MenuBookTwoTone';
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import { shallowEqual, useSelector } from "react-redux";
import { toast } from "react-toastify";

const useStyles = makeStyles(theme => ({
  root: {
    /*"& .MuiPaper-root": {
      borderBottom: "none",
      backgroundColor:"transparent",
      boxShadow:"none"
    },*/
    "& .MuiInput-underline:before":{
      borderBottom: 0,
    },
    "& .MuiInput-underline:after":{
      borderBottom: 0,
    },
    "& .MuiInput-root":{
      borderBottom: 0,
    },
    "&:last-child td": {
      // borderBottom: 0,
    },
  },
  typography: {
    padding: theme.spacing(3),
    boxShadow: theme.shadows[10],
    background: "linear-gradient(to bottom, #3699FF, #1BC5BD)"
  }
}));

export default function MasterUser() {
  const [masterUser, setMasterUser] = useState([]);
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [totalMasterUsers, setTotalMasterUsers] = useState();
  const [newUsers, setNewUsers] = useState();

  const columns = [
    { title: "Full Name", field: "vFullName" },
    { title: "User Name", field: "vUserName" },
    { title: "Email", field: "vEmail" },
    { title: "Phone No", field: "bPhoneNumber" }
  ];

  // ------------------------------------------------------
  // get the master user list on initial loading
  // ------------------------------------------------------
  useEffect(() => {
    fetchMasterUser();
  }, []);
  const encToken = useSelector(({ auth }) => auth.authToken, shallowEqual);
  const history = useHistory();

  const fetchMasterUser = async () => {
    await fetch(CommonUrl.masterUserBaseUrl + "/get-all-master-users", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        token: encToken,
        nonce: NONCE,
        timestamp: TIME_STAMP
      }
    })
      .then(response => response.json())
      .then(response => {
        if (response.code == 401) {
					history.push("/logout");
          toast.info(logoutMsg,{autoClose:5000})
				} else {
        setMasterUser(response.data);
        setTotalMasterUsers(response.totalMasterUsers);
        setNewUsers(response.newUsers);
      }
    });
  };
  // ------------------------------------------------------
  // selected row details show in popup & selected sub users
  // ------------------------------------------------------
  const showDetails = selectedRow => {
    setSelectedUser(selectedRow);
    handleOpen();
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const allDetailsView = rowData => {
    history.push("/master-user/all-details", rowData);
  };

  const handleSelectedSubUser = async rowData => {
    const id = toast.loading("Processing...");

    await fetch(CommonUrl.masterUserBaseUrl + "/sub-users", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        _id: rowData._id
      }
    })
      .then(response => response.json())
      .then(response => {
        if (response.code == 200) {
          history.push(`/subordinate-user/${rowData._id}`);
          toast.update(id, {
            render: response.message,
            type: "success",
            isLoading: false,
            autoClose: 3000
          });
        } else {
          // toast.error(response.message);
          toast.update(id, {
            render: response.message,
            type: "error",
            isLoading: false,
            autoClose: 3000
          });
        }
      });
  };

  return (
    <div className="">
      <div className="pb-5">
        {/* user details widget start */}
        <WidgetForMasterUser
          totalMasterUsers={totalMasterUsers}
          newTotalUsers={newUsers}
        />
        {/* user details widget end */}
      </div>
      <div className="">
        {/* user pop-up start */}
        <Popover
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "center",
            horizontal: "center"
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "center"
          }}
        >
          <div className={classes.typography}>
            <Typography className="text-white">
              Id : <h5 className="font-weight-bold"> {selectedUser._id} </h5>
            </Typography>
            <Typography className="text-white">
              Full Name :{" "}
              <h5 className="font-weight-bold"> {selectedUser.vFullName} </h5>
            </Typography>
            <Typography className="text-white">
              Username :{" "}
              <h5 className="font-weight-bold"> {selectedUser.vUserName} </h5>
            </Typography>
            <Typography className="text-white">
              Email :{" "}
              <h5 className="font-weight-bold"> {selectedUser.vEmail} </h5>
            </Typography>
            <Typography className="text-white">
              Phonen Number :{" "}
              <h5 className="font-weight-bold">
                {" "}
                {selectedUser.bPhoneNumber}{" "}
              </h5>
            </Typography>
            <Typography className="text-white">
              Created At :{" "}
              <h5 className="font-weight-bold">
                {" "}
                {moment(selectedUser.iCreatedAt * 1000).format(
                  "MMMM Do YYYY, h:mm:ss a"
                )}
              </h5>
            </Typography>
            <Typography className="text-white">
              Updated At :{" "}
              <h5 className="font-weight-bold">
                {" "}
                {moment(selectedUser.iUpdatedAt * 1000).format(
                  "MMMM Do YYYY, h:mm:ss a"
                )}
              </h5>
            </Typography>
          </div>
        </Popover>
        {/* user pop-up end */}

        {/* data table start */}
        <div className={classes.root}>
          <MaterialTable
            style={{ paddingInline: "30px", paddingTop: "10px" }}
            title="Master-User List"
            data={masterUser}
            columns={columns}
            actions={[
              // {
              //     icon: MenuBookTwoToneIcon,
              //     tooltip: "User's All Details",
              //     onClick: (event, rowData) => { allDetailsView(rowData) }
              // },
              {
                icon: AssignmentIndIcon,
                tooltip: "Sub-Ordinate User",
                onClick: (event, rowData) => {
                  handleSelectedSubUser(rowData);
                }
              }
            ]}
            options={{
              actionsColumnIndex: -1,
              addRowPosition: "first",
              emptyRowsWhenPaging: false, // To avoid of having empty rows
              headerStyle: {
                width: 200,
                minWidth: 200,
                fontWeight: 600,
                color: "#b5b5c3",
                fontSize: ".9rem",
                textTransform: "uppercase",
                letterSpacing: ".1rem",
              },
              actionsCellStyle: {
                paddingLeft: "60px"
              },
              searchFieldStyle:mySearchFieldStyle
            }}
            onRowClick={(evt, selectedRow) => {
              showDetails(selectedRow);
            }}
          />
        </div>
        {/* data table end */}
      </div>
    </div>
  );
}
